import { FeatureToggleClientService } from 'feature-toggle-client';
const newTeamMembers = 'new_team_members';
const paginatioHhome = 'main_page_pagination';
export class TenantFeatures {
    static newTeamMembers() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(newTeamMembers);
    }
    static paginationHomeInApplication() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(paginatioHhome);
    }
}
